module.exports = __webpack_public_path__ + "img/meme_24.59b7c342.jpg";